function read(name: string): string {
  const value = import.meta.env[name];
  if (typeof value !== 'string' || value.length === 0) {
    throw new Error(
      `Missing required env var ${name}. Copy web/.env.example to web/.env.local and fill it in.`,
    );
  }
  return value;
}

export const config = {
  awsRegion: read('VITE_AWS_REGION'),
  userPoolId: read('VITE_USER_POOL_ID'),
  userPoolClientId: read('VITE_USER_POOL_CLIENT_ID'),
  userPoolDomain: read('VITE_USER_POOL_DOMAIN'),
  identityPoolId: read('VITE_IDENTITY_POOL_ID'),
  sourceBucket: read('VITE_SOURCE_BUCKET'),
  thumbnailsBucket: read('VITE_THUMBNAILS_BUCKET'),
  captionsBucket: read('VITE_CAPTIONS_BUCKET'),
  uploadsTable: read('VITE_UPLOADS_TABLE'),
  sharedLibraryTable: read('VITE_SHARED_LIBRARY_TABLE'),
  sharedLibraryByTimeIndex: read('VITE_SHARED_LIBRARY_BY_TIME_INDEX'),
  playlistsTable: read('VITE_PLAYLISTS_TABLE'),
  playlistsByTimeIndex: read('VITE_PLAYLISTS_BY_TIME_INDEX'),
  apiBaseUrl: read('VITE_API_BASE_URL'),
  spaDomain: read('VITE_SPA_DOMAIN'),
} as const;

export type Config = typeof config;
